export default __webpack_public_path__ + "static/banner-vid-pure-plank-23f02096d8d0c28340c19c7ae18b77e5.webm";